import { Extension } from '@tiptap/core';
import { TextSelection } from '@tiptap/pm/state';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        zyProof: {
            insertZyProof: () => ReturnType;
        };
    }
}

export const ZyProof = Extension.create({
    name: 'zyProof',

    addCommands() {
        return {
            insertZyProof:
                () =>
                ({ chain }) => {
                    return chain()
                        .focus()
                        .insertContent({
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Proof.',
                                    marks: [
                                        {
                                            type: 'bold',
                                        },
                                    ],
                                },
                            ],
                        })
                        .insertContent({
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: '\u00A0■',
                                },
                            ],
                        })
                        .command(({ tr }) => {
                            const positionBeforeSquare = tr.selection.from - 1;
                            tr.setSelection(TextSelection.create(tr.doc, positionBeforeSquare));
                            return true;
                        })
                        .run();
                },
        };
    },
});

export default ZyProof;
